<bic-popup (close)="onClose()" [customClass]="'w-[600px]'" [hasBackdrop]="true"
           [title]="isDeleteMode ? (isRuleset ? 'Geteilten myCheck löschen' : 'Geteilten Prüflauf archivieren') : 'Eigentümer ändern'">
  <div bicPopupContent class="flex flex-col gap-4">
    @if (isDeleteMode) {
      <p class="text-sm text-gray-900">
        „{{ itemName }}" ist mit anderen Projekten geteilt. Sie können den Besitz an eines dieser
        Projekte übergeben – dort bleibt {{ noun }} erhalten – oder ihn
        aus allen Projekten entfernen.
      </p>
    } @else {
      <p class="text-sm text-gray-900">
        Wählen Sie das Projekt, dem „{{ itemName }}" künftig gehören soll. Nur dort kann
        {{ noun }} dann bearbeitet und gelöscht werden.
        @if (!isRuleset) {
          Die verwendeten myChecks bleiben in ihrem Projekt.
        }
      </p>
    }

    @if (loading) {
      <div class="flex flex-row items-center gap-2">
        <fa-icon [icon]="faSpinnerThird" class="animate-spin text-sm text-gray-500"></fa-icon>
        <span class="text-xs text-gray-500">Projekte werden geladen...</span>
      </div>
    } @else if (loadFailed) {
      <div class="flex flex-row items-start gap-2 rounded-lg border border-yellow-200 bg-yellow-50 p-3">
        <fa-icon [icon]="faTriangleExclamation" class="mt-0.5 shrink-0 text-sm text-yellow-700"></fa-icon>
        <span class="text-xs font-medium text-yellow-900">
          Die Projekte konnten nicht geladen werden. Bitte versuchen Sie es erneut.
        </span>
      </div>
    } @else {
      @if (isDeleteMode) {
        <div class="flex flex-col gap-3">
          <label (click)="choose('transfer')"
                 [tooltip]="transferTooltip" tooltipDirection="top"
                 class="flex flex-row items-center gap-3 rounded-lg border p-3"
                 [class.border-green]="choice === 'transfer'"
                 [class.border-gray-200]="choice !== 'transfer'"
                 [class.cursor-pointer]="transferCandidates.length > 0"
                 [class.opacity-50]="transferCandidates.length === 0"
                 [class.cursor-not-allowed]="transferCandidates.length === 0">
            <input [checked]="choice === 'transfer'"
                   [disabled]="saving || transferCandidates.length === 0"
                   class="h-4 w-4 shrink-0 border-gray-300 text-green accent-green focus:ring-green"
                   name="ownership-choice" type="radio"/>
            <span class="flex flex-col">
              <span class="text-sm font-medium text-gray-900">Besitz übergeben</span>
              <span class="text-xs text-gray-500">
                @if (isRuleset) {
                  Das gewählte Projekt wird Eigentümer, in diesem Projekt verschwindet der myCheck.
                    Prüfläufe hier verwenden ihn danach nicht mehr.
                } @else {
                  Das gewählte Projekt wird Eigentümer, in diesem Projekt verschwindet der Prüflauf.
                  Bereits erstellte Berichte bleiben hier erhalten.
                }
              </span>
            </span>
          </label>

          <label (click)="choose('delete-everywhere')"
                 [tooltip]="deleteEverywhereTooltip" tooltipDirection="top"
                 class="flex flex-row items-center gap-3 rounded-lg border p-3"
                 [class.border-red]="choice === 'delete-everywhere'"
                 [class.border-gray-200]="choice !== 'delete-everywhere'"
                 [class.cursor-pointer]="canDeleteEverywhere"
                 [class.opacity-50]="!canDeleteEverywhere"
                 [class.cursor-not-allowed]="!canDeleteEverywhere">
            <input [checked]="choice === 'delete-everywhere'"
                   [disabled]="saving || !canDeleteEverywhere"
                   class="h-4 w-4 shrink-0 border-gray-300 text-red accent-red focus:ring-red"
                   name="ownership-choice" type="radio"/>
            <span class="flex flex-col">
              <span class="text-sm font-medium text-gray-900">
                {{ isRuleset ? 'Aus allen Projekten löschen' : 'Aus allen Projekten entfernen und archivieren' }}
              </span>
              <span class="text-xs text-gray-500">
                @if (isRuleset) {
                  Der myCheck wird überall entfernt, auch aus den Prüfläufen der anderen Projekte.
                  Bereits erstellte Berichte bleiben erhalten.
                } @else {
                  Der Prüflauf verschwindet aus allen Projekten und wird hier archiviert – Sie können
                  ihn über den Filter „Archiviert" wiederherstellen. Berichte bleiben erhalten.
                }
              </span>
            </span>
          </label>
        </div>
      }

      @if (isTransfer) {
        <div class="flex flex-col gap-2">
          <span class="text-xs font-medium text-gray-500">Neuer Eigentümer</span>
          <div class="flex max-h-[220px] flex-col gap-2 overflow-y-auto">
            @for (target of linked; track target.projectId) {
              <label (click)="selectOwner(target)"
                     [tooltip]="target.allowed ? noTooltip : 'Für dieses Projekt fehlen Ihnen die nötigen Rechte.'"
                     tooltipDirection="top"
                     class="flex flex-row items-center gap-3 rounded-lg border bg-white px-3 py-2.5"
                     [class.border-green]="newOwnerProjectId === target.projectId"
                     [class.border-gray-200]="newOwnerProjectId !== target.projectId"
                     [class.cursor-pointer]="target.allowed"
                     [class.opacity-50]="!target.allowed"
                     [class.cursor-not-allowed]="!target.allowed">
                <input [checked]="newOwnerProjectId === target.projectId"
                       [disabled]="saving || !target.allowed"
                       class="h-4 w-4 shrink-0 border-gray-300 text-green accent-green focus:ring-green"
                       name="new-owner" type="radio"/>
                <span class="truncate text-sm font-medium text-gray-900">{{ target.name }}</span>
              </label>
            }
          </div>
        </div>

        @if (!isDeleteMode) {
          <label class="flex flex-row items-center gap-3 cursor-pointer">
            <input [(ngModel)]="keepCurrentOwner"
                   [disabled]="saving"
                   class="h-4 w-4 shrink-0 rounded border-gray-300 text-green accent-green focus:ring-green"
                   type="checkbox"/>
            <span class="text-sm text-gray-900">
              In diesem Projekt weiter als {{ isRuleset ? 'geteilten myCheck' : 'geteilten Prüflauf' }} verwenden
            </span>
          </label>
        }
      }

      @if (showRulesetWarningSection) {
        @if (referencedRulesetsLoadFailed) {
          <div class="flex flex-row items-start gap-2 rounded-lg border border-yellow-200 bg-yellow-50 p-3">
            <fa-icon [icon]="faTriangleExclamation" class="mt-0.5 shrink-0 text-sm text-yellow-700"></fa-icon>
            <span class="text-xs font-medium text-yellow-900">
              Die verwendeten myChecks konnten nicht geprüft werden. Ob sie in „{{ newOwnerName }}"
              verfügbar sind, ist deshalb unklar.
            </span>
          </div>
        } @else if (rulesetsMissingAtNewOwner.length > 0) {
          <div class="flex flex-row items-start gap-2 rounded-lg border border-yellow-200 bg-yellow-50 p-3">
            <fa-icon [icon]="faTriangleExclamation" class="mt-0.5 shrink-0 text-sm text-yellow-700"></fa-icon>
            <div class="flex min-w-0 flex-col gap-1">
              <span class="text-xs font-medium text-yellow-900">
                {{ rulesetsMissingAtNewOwner.length === 1 ? 'Dieser myCheck bleibt' : 'Diese myChecks bleiben' }}
                in {{ rulesetsMissingAtNewOwner.length === 1 ? 'seinem' : 'ihrem' }} Projekt und
                {{ rulesetsMissingAtNewOwner.length === 1 ? 'ist' : 'sind' }} mit „{{ newOwnerName }}" nicht
                geteilt. Der Prüflauf führt {{ rulesetsMissingAtNewOwner.length === 1 ? 'ihn' : 'sie' }}
                weiter aus, in „{{ newOwnerName }}
                " {{ rulesetsMissingAtNewOwner.length === 1 ? 'fehlt er' : 'fehlen sie' }}
                aber in den Listen.
              </span>
              <ul class="list-disc pl-4 text-xs text-yellow-900">
                @for (ruleset of rulesetsMissingAtNewOwner; track ruleset.id) {
                  <li class="truncate">
                    {{ ruleset.name }}@if (ruleset.ownerProjectName) {
                    <span class="text-yellow-700"> · {{ ruleset.ownerProjectName }}</span>
                  }
                  </li>
                }
              </ul>
            </div>
          </div>
        }
      }

      @if (!isTransfer && isRuleset) {
        <div class="flex flex-row items-start gap-2 rounded-lg border border-yellow-200 bg-yellow-50 p-3">
          <fa-icon [icon]="faTriangleExclamation" class="mt-0.5 shrink-0 text-sm text-yellow-700"></fa-icon>
          <span class="text-xs font-medium text-yellow-900">
            Das Löschen kann nicht rückgängig gemacht werden.
          </span>
        </div>
      }
    }
  </div>

  <div bicPopupButtonGroup class="flex w-full flex-row items-center justify-end gap-4">
    <bic-button (onClick)="onClose()" [disabled]="saving" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="onConfirm()" [disabled]="confirmDisabled" [loading]="saving">{{ confirmLabel }}</bic-button>
  </div>
</bic-popup>
